export default __webpack_public_path__ + "static/media/hockey1.a10f4a42.png";